module.exports = {
    defaultImage         : `${CDN_URL}/noimage.jpg`,
    DEFAULT_PAGE_SIZE: 10,
    DEFAULT_FALLBACK_LANGUAGE: 'en',
};
